<template>
  <ModuleSection
    title="汇款申报查询"
    desc="当您有一笔汇出汇款已提交后，请及时提交汇出汇款申报材料，以免影响您的汇款进度。">
    <!-- 查询表单 -->
    <el-form
      ref="queryForm"
      :model="formData"
      :rules="rules"
      label-position="left">
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('账号')"
            prop="account">
            <el-select
              v-model="formData.account"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option
                v-for="(item, index) in accountMap"
                :key="index"
                :label="item.label | translateFilter"
                :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('申报状态')"
            prop="status">
            <el-select
              v-model="formData.status"
              :placeholder="$t('请选择')"
              style="width:100%">
              <el-option :label="$t('全部')" value="" />
              <el-option
                v-for="(item, index) in statusMap"
                :key="index"
                :label="$t(item)"
                :value="index" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="display: flex;">
        <el-col :span="12" style="margin-right: 40px;">
          <el-form-item
            :label="$t('开始日期')"
            prop="beginDate">
            <el-date-picker
              v-model="formData.beginDate"
              :placeholder="$t('请选择')"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsStart"
              @change="changeStartDate"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('结束日期')"
            prop="endDate">
            <el-date-picker
              v-model="formData.endDate"
              :placeholder="$t('请选择')"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsEnd"
              @change="changeEndDate"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 查询按钮 -->
    <el-row style="margin: 20px 0 40px;">
      <el-button class="btn140" @click="handleQuery">{{ $t('查询') }}</el-button>
    </el-row>
    <!-- 汇款申报查询列表 -->
    <DataTable
      :data="declareTableData"
      :loading="declareTableLoading">
      <el-table-column
        :label="$t('申报时间')"
        prop="reportTime">
        <template slot-scope="scope">
          <p>{{ $_format.formatTimeString(scope.row.reportTime).split(' ')[0] }}</p>
          <p>{{ $_format.formatTimeString(scope.row.reportTime).split(' ')[1] }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('业务参考号')"
        prop="reportId">
       </el-table-column>
      <el-table-column
        :label="$t('账号')"
        width="140"
        prop="accNo">
      </el-table-column>
      <el-table-column
        :label="$t('汇款金额')"
        prop="amount">
        <template slot-scope="scope">
          <p>{{ $_format.toCashWithComma(scope.row.amount) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('币种')"
        width="100"
        prop="currency">
        <template slot-scope="scope">
          <p>{{ $t($_params.GRB_CURRENCY_TYPE[scope.row.currency]) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('汇款用途')"
        prop="purpose">
        <template slot-scope="scope">
          {{$t($_params.payUseList[scope.row.purpose]) || scope.row.purpose}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('申报状态')"
        prop="status">
        <template slot-scope="scope">
          <p>{{ $t(declareStatusMap[scope.row.status]) }}</p>
          <p
            v-if="scope.row.status === 'PASS' || scope.row.status === 'PASS2'"
            style="color: #999;">
            {{ $t('近期请关注账户入金') }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('操作')">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleViewDetail(scope.row)">
            {{ $t(scope.row.status === 'REJECT' ? '重新提交' : '查看详情') }}
          </el-link>
        </template>
      </el-table-column>
    </DataTable>
    <!-- 分页 -->
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNum"
      :page-size.sync="pageSize"
      :total="total"
      layout="prev, pager, next, jumper" />
  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
import { transformObj2SelectOptionsArray } from '@/utils/form/genOptions'
import { mapState } from 'vuex'
import declareApi from './api'
import { declareStatusMap } from './constants'
export default {
  name: 'DeclareOutwardQueryCache',
  components: {
    ModuleSection
  },
  data () {
    const statusMap = this.$_format.getFilterObj(declareStatusMap, ['WAIT', 'PASS', 'REJECT', 'REFUND'])
    return {
      /* 查询表单 */
      accountMap: {},
      // 筛选出 审核中 审核通过 审核拒绝 已退款
      declareStatusMap,
      statusMap,
      formData: {
        account: '',
        status: '',
        beginDate: '',
        endDate: ''
      },
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      /* 查询表格 */
      declareTableData: [],
      declareTableLoading: false,
      /* 分页 */
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    ...mapState('account', ['accountInfo']),
    rules () {
      return {
        account: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        beginDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ],
        endDate: [
          { required: true, message: this.$t('请选择'), trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.formData.endDate = this.$_format.getToday()
    this.formData.beginDate = this.$_format.getLastDay(this.formData.endDate, 7)
    this.accountMap = transformObj2SelectOptionsArray(this.$_params.getSessionAccountSelect_obj('ALL', true, 0, 0)) || []
    this.formData.account = this.accountMap[0].value
  },
  activated () {
    this.getDeclareTableData()
  },
  methods: {
    /* 表单按钮 */
    changeStartDate () {
      const beginDateStamp = new Date(this.formData.beginDate).getTime()
      const endDateStamp = new Date(this.formData.endDate).getTime()
      if (beginDateStamp > endDateStamp) {
        this.formData.endDate = ''
      }
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          return time.getTime() < beginDateStamp
        }
      })
    },
    changeEndDate () {
      const beginDateStamp = new Date(this.formData.beginDate).getTime()
      const endDateStamp = new Date(this.formData.endDate).getTime()
      if (endDateStamp < beginDateStamp) {
        this.formData.beginDate = ''
      }
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          return time.getTime() > new Date(this.formData.endDate).getTime()
        }
      })
    },
    // 查询
    getDeclareTableData () {
      const { formData, pageNum, pageSize } = this
      this.declareTableLoading = true
      return declareApi.getDeclareTableData({
        ...formData,
        accNo: formData.account.split('|')[0],
        pageNum,
        pageSize,
        currentBusinessCode: '10101300'
      }).then(res => {
        this.declareTableLoading = false
        if (res) {
          const { list, totalSize } = res
          this.declareTableData = list
          this.total = totalSize
        }
      }).catch(err => {
        this.declareTableLoading = false
        console.error(err)
      })
    },
    handleQuery () {
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          this.pageNum = 1
          this.getDeclareTableData()
        }
      })
    },
    /* 查询表格 */
    // 查看详情
    handleViewDetail (row) {
      const { accNo, reportId } = row
      this.$router.push({
        name: 'DeclareOutwardDetail',
        query: {
          type: 'Detail',
          accNo,
          reportId
        }
      })
    },
    /* 分页 */
    handleSizeChange () {
      this.getDeclareTableData()
    },
    handleCurrentChange () {
      this.getDeclareTableData()
    }
  }
}
</script>

<style scoped lang="less">
.btn140 {
  min-width: 140px;
}
</style>
